var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 15.75H11.25M6.75 15.75V12M6.75 15.75H2.7C2.45147 15.75 2.25 15.5485 2.25 15.3V12.45C2.25 12.2015 2.45147 12 2.7 12H6.75M11.25 15.75V6.75M11.25 15.75H15.3C15.5485 15.75 15.75 15.5485 15.75 15.3V2.7C15.75 2.45147 15.5485 2.25 15.3 2.25H11.7C11.4515 2.25 11.25 2.45147 11.25 2.7V6.75M6.75 12V7.2C6.75 6.95147 6.95147 6.75 7.2 6.75H11.25",
    stroke: "#B5B5B5",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.47c899a12aaffbd902818ba946081d6d.svg";
export { ForwardRef as ReactComponent };